import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable()
export class UtilSubdomain {

    constructor(@Inject(DOCUMENT) private document: Document) {
    }

    getSubdomain(): string {
        let url: string = this.document.location.hostname;

        if (url === 'localhost' || url.includes('dev-fwd') || url.includes('192.168')) {
            url = 'dev-fwd';
        } else if (url.includes('prod-fwd')) {
          url = 'fwd';
        } else {
            if (url.includes('.fitscovery.com')) {
                url = url.replace('.fitscovery.com', '');
            } else {
                console.error(url);
            }
        }

        return url;
    }
}
